import type { ReactNode } from "react";

/** Labelled form field (U17) — the one label wrapper (was 2 components + ~6
 *  inline label-style copies). Uppercase small label + optional required star. */
export function Field({ label, req = false, children }: {
  label: ReactNode; req?: boolean; children: ReactNode;
}) {
  return (
    <div>
      <label style={{ display: "block", fontSize: 10, fontWeight: 800, letterSpacing: ".8px", textTransform: "uppercase", color: "var(--t-mute)", marginBottom: 6 }}>
        {label} {req && <span style={{ color: "var(--orange)" }}>*</span>}
      </label>
      {children}
    </div>
  );
}

/** Filter/action row (U19) — the flex-gap-wrap cluster with a right-aligned
 *  slot that was re-tuned by hand four times on the registry pages alone. */
export function Toolbar({ children, right, style }: {
  children?: ReactNode; right?: ReactNode; style?: React.CSSProperties;
}) {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", ...style }}>
      {children}
      {right && <><span style={{ marginLeft: "auto" }} />{right}</>}
    </div>
  );
}
